module.exports = __webpack_public_path__ + "static/eclipse-52adf2a37dd5b40a2b0f562917bb2ea7.jpg";